import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";

/* ===================== DATA ===================== */

const coreValues = [
  {
    title: "Expertise",
    description:
      "Our team comprises seasoned developers with years of experience in API and Microservices development.",
  },
  {
    title: "Innovation",
    description:
      "We stay ahead of the curve by embracing the latest technologies, frameworks, and best practices.",
  },
  {
    title: "Collaboration",
    description:
      "We believe in fostering strong partnerships with our clients, working closely with them to achieve shared goals.",
  },
  {
    title: "Support",
    description:
      "Our commitment to customer satisfaction extends beyond project delivery. We provide ongoing support and maintenance to ensure long-term success.",
  },
];

const solutions = [
  {
    title: "Analytics",
    description:
      "Transform data into actionable insights using advanced analytics and reporting solutions.",
  },
  {
    title: "Apps",
    description:
      "Design and develop scalable web and mobile applications tailored to your business needs.",
  },
  {
    title: "Strategy",
    description:
      "Define clear digital strategies that align technology initiatives with business objectives.",
  },
  {
    title: "Digital",
    description:
      "Accelerate digital transformation through modern platforms, automation, and cloud adoption.",
  },
  {
    title: "Management",
    description:
      "Streamline operations and improve efficiency with intelligent management systems.",
  },
  {
    title: "Enterprise",
    description:
      "Enterprise-grade solutions built for performance, security, and scalable growth.",
  },
];

/* ===================== COMPONENT ===================== */

export default function Solutions() {
  return (
    <Box sx={{ py: 10, backgroundColor: "background.paper" }}>
      <Container>

        {/* ===== CORE VALUES ===== */}
        <Typography variant="h4" align="center">
          Why Choose Us
        </Typography>
        <Typography align="center" color="primary" gutterBottom>
          OUR STRENGTHS
        </Typography>

        <Grid container spacing={4} mt={2}>
          {coreValues.map((item) => (
            <Grid item xs={12} md={3} key={item.title}>
              <Card sx={{ height: "100%" }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography color="text.secondary">
                    {item.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* ===== SOLUTIONS ===== */}
        <Box mt={10}>
          <Typography variant="h4" align="center">
            Our Solutions
          </Typography>
          <Typography align="center" color="primary" gutterBottom>
            WHAT WE DO
          </Typography>

          <Grid container spacing={4} mt={2}>
            {solutions.map((item) => (
              <Grid item xs={12} md={4} key={item.title}>
                <Card sx={{ height: "100%" }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {item.title}
                    </Typography>
                    <Typography color="text.secondary">
                      {item.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

      </Container>
    </Box>
  );
}
